var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#063C4F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.03394 13.8564C3.12236 13.8588 3.21108 13.8601 3.3001 13.8601C5.13071 13.8601 6.83857 13.3346 8.28106 12.4261C8.87157 15.4655 11.5477 17.7601 14.7597 17.7601C17.3886 17.7601 19.6584 16.2231 20.7198 13.9988C20.802 13.9553 20.8833 13.9101 20.9635 13.8633C19.8036 17.7148 16.2293 20.5201 11.9997 20.5201C7.76769 20.5201 4.19163 17.7114 3.03394 13.8564Z",
    fill: "url(#paint0_radial_930_8872_swth)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.03394 13.8564C3.12236 13.8588 3.21108 13.8601 3.3001 13.8601C5.13071 13.8601 6.83857 13.3346 8.28106 12.4261C8.87157 15.4655 11.5477 17.7601 14.7597 17.7601C17.3886 17.7601 19.6584 16.2231 20.7198 13.9988C20.802 13.9553 20.8833 13.9101 20.9635 13.8633C19.8036 17.7148 16.2293 20.5201 11.9997 20.5201C7.76769 20.5201 4.19163 17.7114 3.03394 13.8564Z",
    fill: "#04171E",
    fillOpacity: 0.88
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.07861 14.0014C3.15216 14.0031 3.22592 14.004 3.29989 14.004C5.14154 14.004 6.85897 13.4721 8.30694 12.5536C8.94658 15.5294 11.5926 17.76 14.7595 17.76C17.3884 17.76 19.6582 16.2231 20.7195 13.9987C20.8018 13.9552 20.8831 13.9101 20.9632 13.8632C19.8033 17.7147 16.229 20.52 11.9995 20.52C7.82078 20.52 4.28161 17.7816 3.07861 14.0014Z",
    fill: "url(#paint1_radial_930_8872_swth)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.07861 14.0014C3.15216 14.0031 3.22592 14.004 3.29989 14.004C5.14154 14.004 6.85897 13.4721 8.30694 12.5536C8.94658 15.5294 11.5926 17.76 14.7595 17.76C17.3884 17.76 19.6582 16.2231 20.7195 13.9987C20.8018 13.9552 20.8831 13.9101 20.9632 13.8632C19.8033 17.7147 16.229 20.52 11.9995 20.52C7.82078 20.52 4.28161 17.7816 3.07861 14.0014Z",
    fill: "#04171E",
    fillOpacity: 0.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4279 17.5474C15.0971 18.6543 13.3863 19.32 11.52 19.32C8.03633 19.32 5.09439 17.0005 4.1543 13.8216C5.66139 13.6852 7.06539 13.1916 8.28094 12.4261C8.87145 15.4655 11.5476 17.7601 14.7596 17.7601C15.336 17.7601 15.895 17.6862 16.4279 17.5474Z",
    fill: "url(#paint2_linear_930_8872_swth)",
    fillOpacity: 0.64
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6801 11.16C19.6801 15.4015 16.2416 18.84 12.0001 18.84C7.75852 18.84 4.32007 15.4015 4.32007 11.16C4.32007 6.91843 7.75852 3.47998 12.0001 3.47998C16.2416 3.47998 19.6801 6.91843 19.6801 11.16Z",
    fill: "url(#paint3_radial_930_8872_swth)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1694 9.71787C19.1694 12.7002 16.7517 15.1179 13.7694 15.1179C10.787 15.1179 8.36938 12.7002 8.36938 9.71787C8.36938 6.73553 10.787 4.31787 13.7694 4.31787C16.7517 4.31787 19.1694 6.73553 19.1694 9.71787Z",
    fill: "url(#paint4_radial_930_8872_swth)",
    fillOpacity: 0.6
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5036 4.32758C12.3831 4.32113 12.2618 4.31787 12.1398 4.31787C10.9909 4.31787 9.90947 4.60694 8.96436 5.11633C9.46981 5.00495 9.99503 4.94623 10.534 4.94623C11.0833 4.94623 11.6183 5.00723 12.1328 5.12283L12.5036 4.32758Z",
    fill: "url(#paint5_linear_930_8872_swth)",
    fillOpacity: 0.64
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9479 5.35715C15.7715 6.35213 17.795 9.04341 17.795 12.2073C17.795 13.5081 17.453 14.7289 16.854 15.7849C18.0817 14.5701 18.8423 12.8841 18.8423 11.0204C18.8423 7.74217 16.4888 5.01362 13.3792 4.43224L12.9479 5.35715Z",
    fill: "url(#paint6_linear_930_8872_swth)",
    fillOpacity: 0.64
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1042 17.6527C14.917 18.4048 13.5093 18.8402 11.9999 18.8402C9.60789 18.8402 7.47126 17.7466 6.06274 16.0321C6.45103 16.1032 6.8512 16.1404 7.26004 16.1404C10.2287 16.1404 12.7396 14.1804 13.5693 11.4838C13.843 11.5079 14.1201 11.5202 14.4001 11.5202C16.318 11.5202 18.1013 10.9433 19.5857 9.95361C19.6477 10.3467 19.6799 10.7497 19.6799 11.1602C19.6799 11.415 19.6675 11.6669 19.6433 11.9154C19.2119 14.2453 17.9175 16.2724 16.1042 17.6527Z",
    fill: "url(#paint7_linear_930_8872_swth)",
    fillOpacity: 0.64
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.03638 13.8632C4.19618 17.7148 7.77056 20.5202 12.0002 20.5202C17.1497 20.5202 21.3279 16.3619 21.36 11.2199C20.8463 11.2167 20.3424 11.1721 19.8515 11.0892C18.6978 11.5977 17.422 11.88 16.0802 11.88C15.615 11.88 15.1576 11.8461 14.7106 11.7805C13.8819 14.4786 11.3702 16.4401 8.40043 16.4401C6.3295 16.4401 4.48135 15.4863 3.2713 13.994C3.19202 13.952 3.1137 13.9083 3.03638 13.8632Z",
    fill: "url(#paint8_linear_930_8872_swth)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3599 11.228C19.9832 12.0243 18.3849 12.4801 16.6801 12.4801C16.3552 12.4801 16.0342 12.4635 15.7178 12.4312C15.1253 15.4681 12.4504 17.7601 9.2401 17.7601C6.61127 17.7601 4.34142 16.2232 3.28008 13.9988C3.1978 13.9553 3.11655 13.9102 3.03638 13.8633C4.19629 17.7148 7.77058 20.5201 12.0001 20.5201C17.1468 20.5201 21.3233 16.3661 21.3599 11.228Z",
    fill: "url(#paint9_radial_930_8872_swth)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6775 11.5861C20.1137 11.8527 19.519 12.0647 18.9002 12.2153C18.82 12.8988 18.6657 13.5842 18.4325 14.2615C17.864 15.9125 16.8964 17.3126 15.6746 18.391C17.7638 17.3857 19.466 15.5781 20.2805 13.2127C20.466 12.6741 20.5973 12.1299 20.6775 11.5861Z",
    fill: "url(#paint10_linear_930_8872_swth)",
    fillOpacity: 0.64
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7065 11.7967C14.717 11.7825 14.7368 11.7799 14.7505 11.7908C15.0629 12.0386 15.4006 12.2573 15.7625 12.4427C15.7781 12.4507 15.7844 12.4701 15.7767 12.4861C15.7689 12.5021 15.7501 12.5086 15.7346 12.5007C15.3689 12.3133 15.0278 12.0924 14.7122 11.8421C14.6985 11.8312 14.6959 11.8108 14.7065 11.7967Z",
    fill: "url(#paint11_linear_930_8872_swth)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_930_8872_swth",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.9635 18.543) rotate(179.948) scale(67.9615 197.47)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.104167,
    stopColor: "#24537E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520341,
    stopColor: "#4FC1C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAFFF4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_930_8872_swth",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.9632 18.543) rotate(179.948) scale(67.9615 197.47)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.104167,
    stopColor: "#24537E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520341,
    stopColor: "#4FC1C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAFFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_930_8872_swth",
    x1: 16.1984,
    y1: 20.6138,
    x2: 13.1106,
    y2: 4.55254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04171E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04171E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_930_8872_swth",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.37969 17.1643) rotate(-57.5402) scale(13.5289 196.041)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.104167,
    stopColor: "#3A78B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520341,
    stopColor: "#4FC1C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CF2FD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_930_8872_swth",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.1399 4.31998) rotate(144.267) scale(13.3046 13.2102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.216485,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906332,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_930_8872_swth",
    x1: 16.8601,
    y1: 7.31998,
    x2: 8.94007,
    y2: 10.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732381,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_930_8872_swth",
    x1: 16.8601,
    y1: 7.31998,
    x2: 8.94007,
    y2: 10.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732381,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_930_8872_swth",
    x1: 31.5608,
    y1: -9.0905,
    x2: -0.831407,
    y2: 17.8967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04171E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04171E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_930_8872_swth",
    x1: 17.9401,
    y1: 12.39,
    x2: 5.79005,
    y2: 16.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E6585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04171E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_930_8872_swth",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.49338 19.5064) rotate(-38.5632) scale(11.0779 172.78)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.104167,
    stopColor: "#3A78B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520341,
    stopColor: "#4FC1C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CF2FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_930_8872_swth",
    x1: 20.7001,
    y1: 11.58,
    x2: 16.0276,
    y2: 18.6624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_930_8872_swth",
    x1: 15.7736,
    y1: 12.4699,
    x2: 14.2547,
    y2: 11.5309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CF2FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CF2FD",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwth);
export default __webpack_public_path__ + "static/media/SWTH.8ba67409c94548319f950997bf808cf1.svg";
export { ForwardRef as ReactComponent };